/**
 * Custom global loader (circular + "Cargando...") via eview-global-loader.
 */
export const globalHttpLoaderEnabled = true;

/**
 * HTTP URLs excluded from the global loader.
 * User-management list endpoints use eview-user-mgmt-loader instead (avoids double overlay).
 */
export const NG_HTTP_LOADER_FILTERED_URL_PATTERNS: string[] = [
  'open\\.mapquestapi\\.com',
  'notifications_ex',
  '/api/v[0-9]+/users(?!/(me|extra))(?:\\?|$)',
  '/api/v[0-9]+/roles(?:\\?|$|/)',
  '/api/v[0-9]+/permissions(?:\\?|$|/)',
];

export const ngHttpLoaderConfigDefaults = {
  backdrop: false,
  backgroundColor: '#000000',
  debounceDelay: 0,
  extraDuration: 0,
  minDuration: 0,
  opacity: 0.35,
  spinner: 'skWanderingCubes' as const,
  filteredUrlPatterns: NG_HTTP_LOADER_FILTERED_URL_PATTERNS,
  globalHttpLoaderEnabled,
};
